<template>
	<div class="tape" v-loading="loading">
		<!-- <div class="t-header">
			<div class="t-h-title">课堂录音</div>
			<div class="t-h-time">2024-04-13 17:30:00</div>
		</div> -->
		<!-- <div class="t-tapeAudio">
			<mini-audio :audio-source="audioUrl" class="audio_class"></mini-audio>
		</div> -->
		<!-- <div class="t-tapeFile"> -->
			<!-- <div class="t-t-header">
				<div class="t-t-h-left">
					<div class="t-t-h-l-Item" :style="cardStatus==0&&foldStatus?'background:white':''" @click.stop="changeCardStatus(0)">
						<span class="t-t-h-l-i-icon"></span>
						<div class="t-t-h-l-i-text">录音原文</div>
					</div>
					<div class="t-t-h-l-Item" :style="cardStatus==1&&foldStatus?'background:white':''" @click.stop="changeCardStatus(1)">
						<span class="t-t-h-l-i-icon"></span>
						<div class="t-t-h-l-i-text">转录文稿.xlsx</div>
					</div>
				</div>
				<div class="t-t-h-right" @click.stop="changeFoldStatus(!foldStatus)">
					<span class="t-t-h-r-icon" :style="`transform: scaleY(${foldStatus==0?1:-1});`"></span>
					<div class="t-t-h-r-text">{{ foldStatus==0 ? '展开' : '收起'}}</div>
				</div>
			</div> -->
			<!-- <div class="t-t-main" v-show="foldStatus">
				<div class="t-t-m-Item" v-show="cardStatus == 0">
					<p v-for="(item, index) in pList" :key="index" v-text="item"></p>
				</div>

				<div class="t-t-m-Item" v-show="cardStatus == 1">
					<iframe
						ref="viframe"
						style="width: 100%; height: 99%; border: none"
						:src="
							'https://view.officeapps.live.com/op/view.aspx?src=' +
							encodeURIComponent(fileUrl)
						"
					></iframe>
				</div>
			</div> -->
		<!-- </div> -->
		<div class="t-chartArea" ref="chartAreaRef">
			<div class="t_ca_box" v-for="(item, index) in chatData" :key="item.uid+index">
			
				<div class="t_ca_b_roleUser" v-if="item.content">
					<div class="t_ca_b_u_content">
						<div class="t_ca_b_u_c_main">
							<div class="t_ca_b_u_c_m_left">
								<!-- <img
									:src="
										require('../../../../assets/icon/classroomObservation/addWork.png')
									"
									@click="addWork()"
								/> -->
								<!-- <img
									:src="
										require('../../../../assets/icon/classroomObservation/copy.svg')
									"
									@click="copyContent(item.content)"
								/> -->
							</div>
							<div class="t_ca_b_u_c_m_right" v-html="item.content"></div>
						</div>
						<div class="t_ca_b_u_c_time">{{ item.createtime }}</div>
					</div>
					<div class="t_ca_b_u_avatar">
						<el-avatar
							size="medium"
							:src="
								require('../../../../assets/icon/classroomObservation/userAvatar.png')
							"
						></el-avatar>
					</div>
				</div>
				<div class="t_ca_b_roleAi">
					<div class="t_ca_b_ai_avatar">
						<el-avatar
							size="medium"
							:src="item.filename?item.filename:require('../../../../assets/icon/classroomObservation/ai.png')"

						></el-avatar>
					</div>
					<div class="t_ca_b_ai_content">
						<div class="t_ca_b_ai_c_name">{{ item.fileid }}</div>
						<div class="t_ca_b_ai_c_main">
							<div class="t_ca_b_ai_c_m_left" v-loading="item.loading" v-html="item.aiContent"></div>
							<div class="t_ca_b_ai_c_m_right">
								<!-- <img
									:src="
										require('../../../../assets/icon/classroomObservation/addWork.png')
									"
									@click="addWork()"
								/> -->
								<img
									:src="
										require('../../../../assets/icon/classroomObservation/copy.svg')
									"
									@click="copyContent(item.aiContent)"
								/>
							</div>
						</div>
						<div class="t_ca_b_ai_c_time">{{ item.createtime }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		
	},
	props: {
		chatData: {
			type: Array,
			default: () => {
				return [];
			},
		},
		aiNameList:{
			type:Array,
			default:()=>{
				return [];
			}
		},
		loading:{
			type:Boolean,
			default:true,
		}
	},
	data() {
		return {
			// foldStatus: false, //0--收起状态   1--展开状态

			fileUrl:
				"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E8%BD%AC%E5%BD%95%E6%96%87%E7%A8%BF1713172600896.xlsx",
			audioUrl:
				"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E8%A7%A3%E5%86%B3%E5%9E%83%E5%9C%BE%E9%97%AE%E9%A2%981713172672090.m4a",
		};
	},
	computed:{
		contentValue(){
			// return (text)=>{
			// 	let newText = text;
			// 	this.aiNameList.forEach(i=>{
			// 		const regex = new RegExp(`@(${i.name})`,"g");
			// 		newText = newText.replace(regex,`<span class='atName'>@$1</span>`);
			// 	})
			// 	return newText;
			// }
		},
	},
	methods: {
		// 切换折叠状态
		// changeFoldStatus(newValue) {
		// 	this.foldStatus = newValue;
		// },
		//切换卡片
		// changeCardStatus(newValue) {
		// 	this.foldStatus = 1;
		// 	this.cardStatus = newValue;
		// },
		addWork() {
			this.$message.info("添加到工作区");
		},
		copyContent(value) {
			const input = document.createElement("input");
			// 设置 display为none会导致无法复制
			// input.style.display = "none";
			// 所以只能用其他方法隐藏
			input.style.opacity = 0;
			// 为了不影响布局
			input.style.position = "fixed";
			input.style.left = "-100%";
			input.style.top = "-100%";
			input.value = value;
			document.body.appendChild(input);
			input.select();
			const success = document.execCommand("copy");
			document.body.removeChild(input);
			if (!success) {
				return this.$message.error("复制失败");
			}else{
				return this.$message.success("复制成功")
			}
		},
	},
};
</script>

<style scoped>
.tape {
	width: 100%;
	height: 100%;
	overflow: auto;
}
.t-header {
	width: 100%;
	height: 30px;
	display: flex;
	align-items: center;
}

.t-h-title {
	font-size: 20px;
	margin-right: 10px;
}
.t-h-time {
	font-size: 14px;
	color: #a8a9ab;
}

.t-tapeAudio {
	width: 100%;
	height: 50px;
	margin-top: 10px;
	box-sizing: border-box;
	padding-right: 30px;
}

.audio_class {
	/* width: 100% !important; */
	/* height: 100% !important; */
	background: #3680fb !important;
	margin: 0 !important;
}

.t-tapeAudio >>> .vueAudioBetter span:before {
	color: #fff;
}

/* .t-tapeAudio>>>.slider{
	width: 80% !important;
} */

.audio_class >>> .slider .process {
	background: #000;
}

.t-tapeAudio >>> .vueAudioBetter .iconfont:active {
	position: unset;
}

.t-tapeFile {
	width: 100%;
	max-height: calc(100vh - 294px);
	overflow: auto;
	/* background-color: red; */
}

.t-t-header {
	width: 100%;
	height: 35px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: #e5e5e5;
	border-radius: 5px 5px 0 0;
	box-sizing: border-box;
	padding-right: 10px;
}

.t-t-h-left {
	width: calc(100% - 80px);
	height: 100%;
	overflow: auto;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	padding-left: 5px;
}

.t-t-h-l-Item {
	width: auto;
	height: 90%;
	box-sizing: border-box;
	padding: 0 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	font-size: 14px;
	margin-right: 10px;
	border-radius: 5px;
}

/* .t-t-h-l-i-icon {
	width: 20px;
	height: 20px;
	background: url("../../../../assets/icon/classroomObservation/file.png")
		no-repeat;
	background-size: 100% 100%;
	margin-right: 5px;
	background-position: center;
} */

.t-t-h-l-Item:hover {
	background-color: white;
}

.t-t-h-right {
	width: 80px;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

/* .t-t-h-r-icon {
	width: 25px;
	height: 25px;
	background: url("../../../../assets/icon/classroomObservation/foldIcon.png")
		no-repeat;
	background-size: 100% 100%;
	margin-right: 10px;
	background-position: center;
	transform: scaleY(-1);
} */

.t-t-h-r-text {
	font-size: 16px;
}

.t-t-main {
	width: 100%;
	height: calc(100vh - 354px);
	/* height: calc(100% - 35px); */
	overflow: auto;
	background-color: white;
}

.t-t-m-Item {
	width: 100%;
	height: 100%;
}

.t-t-m-Item > p {
	margin: 10px;
}

.t-chartArea {
	width: 100%;
	height: calc(100vh - 280px);
	overflow: auto;
}

.t-ca-item {
	width: 100%;
	height: auto;
	margin-top: 20px;
	display: flex;
	justify-content: flex-start;
}

.t-ca-i-left {
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.t-ca-i-right {
	flex: 1;
	height: auto;
	padding: 10px;
	box-sizing: border-box;
}

.t-ca-i-r-name {
	width: 100%;
	font-size: 16px;
	font-weight: 600;
}

.t-ca-i-r-time {
	width: 100%;
	font-size: 14px;
	color: #a8a9ab;
	margin-top: 10px;
}

.t-ca-i-r-content {
	margin-top: 10px;
	width: 100%;
	height: auto;
	white-space: pre-line;
	word-break: break-all;
}

.t_ca_b_roleAi {
	width: 100%;
	height: auto;
	box-sizing: border-box;
	padding: 10px;
	display: flex;
}

.t_ca_b_ai_c_name {
	font-weight: 600;
}
.t_ca_b_ai_c_main {
	width: auto;
	display: flex;
}

.t_ca_b_ai_c_m_left {
	min-width: 50px;
	height: auto;
	padding: 12px;
	display: block;
	border-radius: 2px 8px 8px 8px;
	box-shadow: 0 4px 10px 0 #1d388354;
	margin-top: 10px;
	/* white-space: pre-line; */
	word-break: break-all;
	background-color: white;
	overflow: hidden;
}

.t_ca_b_ai_c_m_right {
	min-width: 30px;
	min-height: 50px;
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	margin-left: 5px;
}

.t_ca_b_ai_c_m_right > img {
	width: 20px;
	height: 20px;
	margin-bottom: 15px;
	cursor: pointer;
}

.t_ca_b_u_c_m_left {
	min-width: 30px;
	min-height: 50px;
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	margin-right: 5px;
}

.t_ca_b_u_c_m_left > img {
	width: 20px;
	height: 20px;
	margin-bottom: 15px;
	cursor: pointer;
}

.t_ca_b_ai_c_time {
	font-size: 14px;
	color: #a8a9ab;
	margin-top: 10px;
}

.t_ca_b_ai_avatar {
	width: 30px;
	height: 30px;
	margin-right: 10px;
}

.t_ca_b_roleUser {
	width: 100%;
	height: auto;
	box-sizing: border-box;
	padding: 10px;
	display: flex;
	justify-content: flex-end;
}

.t_ca_b_u_avatar {
	width: 30px;
	height: 30px;
	margin-left: 10px;
}

.t_ca_b_u_c_main {
	display: flex;
	width: auto;
	justify-content: flex-end;
}
.t_ca_b_u_c_m_right {
	height: auto;
	padding: 12px;
	display: block;
	border-radius: 8px 2px 8px 8px;
	box-shadow: 0 4px 10px 0 #1d388346;
	margin-top: 10px;
	white-space: pre-line;
	word-break: break-all;
	background-color: #3681fc;
	color: white;
}

.t_ca_b_u_c_time {
	white-space: nowrap;
	font-size: 14px;
	color: #a8a9ab;
	margin-top: 10px;
	text-align: right;
}
.t_ca_b_u_c_m_right>>>.aite-name{
	display: inline;
	background-color: #063a708c;
	border-radius: 5px;
	box-sizing: border-box;
	padding: 2px 5px;
	color: white;
	margin-right: 5px;
}

.t_ca_b_ai_c_m_left>>>ol{
	margin-left: 25px;
}

.t_ca_b_ai_c_m_left>>>ul{
	margin-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/tape.vue